<template>
  <div>
    <div class="container">
      <div class="partnerForm">
        <h2>{{ parseTranslation(GROUP) }}: {{ groupName }}</h2>
        <form action="">
          <div>
            <label for="ppid">PPID:</label>
            <input v-model="ppid" type="text" id="ppid" name="ppid" />
          </div>
          <div>
            <label for="clientId">{{ parseTranslation(CLIENT_ID) }}:</label>
            <input v-model="clientId" type="text" id="clientId" name="clientId" />
          </div>
          <div class="card">
            <label for="clientId">{{ parseTranslation(RATE_CARD) }}:*</label>
            <dropdown
              v-if="cards.options.length"
              dropId="rateCard-groups"
              :width="200"
              :options="cards.options"
              :value="cards.card"
              @update="data => (cards.card = data)"
              :top="true"
            >
              <template v-slot:btn="slotProps">
                <div
                  :class="{
                    active: slotProps.opened || slotProps.hover,
                  }"
                  class="chooseDrop"
                >
                  <p>
                    {{ cards.card.text }}
                  </p>
                  <ArrowDrop />
                </div>
              </template>
            </dropdown>
          </div>
          <div class="btnEditGroup">
            <button @click.prevent="editGroup">
              <span v-if="loader"> <Loader color="#fff" /> </span>
              <span v-else> {{ parseTranslation(SAVE_GROUP) }} </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Dropdown from '@/components/DropdownGroups.vue'
import Loader from '@/components/loading/Loader-3'

import ArrowDrop from '@/components/imgs/ArrowDropSelect'

import * as translationEditGroup from './index.translations'

const { default: translations, ...translationKeys } = translationEditGroup

export default {
  name: 'EditGroups',
  props: ['getGroups'],
  components: {
    Dropdown,
    Loader,
    ArrowDrop,
  },
  data() {
    return {
      translations,
      ...translationKeys,
      ppid: '',
      ratecard: '',
      clientId: '',
      rateCards: null,
      cards: {
        card: {
          value: 'Default',
          text: 'Default',
        },
        options: [
          {
            value: 'Default',
            text: 'Default',
          },
        ],
      },
      loader: false,
    }
  },
  computed: {
    groupName() {
      return this.$route.query.groupName
    },
  },
  watch: {
    groupName() {
      this.ppid = ''
      this.ratecard = ''
      this.clientId = ''
      this.loadGroup()
      this.scrollTop()
    },
  },
  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async loadGroup() {
      if (this.$store.getters.accType !== 'Root') return

      const group = await this.executeSurveyAPICall({
        path: 'groups',
        queryParams: { group_name: this.groupName },
      })

      if (!group) return

      this.ppid = group.ppid
      this.ratecard = group.rate_card
      this.clientId = group.clientId
      this.cards.card.value = group.rate_card
      this.cards.card.text = group.rate_card
    },

    async getRateCards() {
      if (this.$store.getters.accType !== 'Root') return

      const cards = await this.executeSurveyAPICall({
        path: 'rate-cards/list',
      })

      if (!cards) return

      cards.forEach((element, index) => {
        if (element.rc_name !== 'Default') {
          this.cards.options.push({
            value: element.rc_name,
            text: element.rc_name,
          })
        }
      })
    },

    async editGroup() {
      if (!this.clientId || !this.ratecard)
        return this.sendMessage(this.translations[this.language][this.REQUIRED_FIELDS])

      this.loader = true

      const updatedGroup = await this.executeSurveyAPICall({
        method: 'PUT',
        path: 'groups',
        payload: {
          group_name: this.groupName,
          rate_card: this.cards.card.text,
          clientId: this.clientId,
          ppid: this.ppid || null,
        },
      })

      if (!updatedGroup) return (this.loader = false)

      this.sendMessage(this.translations[this.language][this.CHANGES_SAVED])

      this.getGroups()

      this.loader = false

      this.$router.push({ name: 'addgroup' })
    },

    scrollTop: function() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },

    scrollListener: function(e) {
      this.visible = window.scrollY > 150
    },
  },

  created() {
    this.loadGroup()
    this.scrollTop()
    this.getRateCards()
  },

  mounted: function() {
    window.addEventListener('scroll', this.scrollListener)
  },

  beforeDestroy: function() {
    window.removeEventListener('scroll', this.scrollListener)
  },
}
</script>

<style lang="scss" scoped>
.partnerForm {
  margin-top: 60px;
  @include tipography(16);
  form {
    display: block;
    flex-wrap: wrap;

    .btnEditGroup {
      margin: 10px 0 0 0;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      button {
        background: $blue;
        border: none;
        border-radius: 3px;
        padding: 8px 15px;
        @include tipography(15);
        letter-spacing: 3px;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
        &:focus {
          outline: none;
        }
      }
    }
  }
  h2 {
    @include tipography(20);
    font-weight: bold;
    margin-bottom: 30px;
  }
  input {
    width: 100%;
    display: block;
    margin: 10px 0 20px;
    @include tipography(16);
    color: $gray-5;
    background: none;
    border: 1px solid $gray-5;
    padding: 8px 10px;
    border-radius: 3px;
    &:focus {
      outline: none;
    }
  }
  .light & {
    color: $gray-6;
    h2,
    input {
      color: $gray-6;
    }
  }
}

.rateCard {
  color: #fff;
  font-weight: 500;
  width: 200px;
  height: 38px;
  font-size: 16px;
  border: 0.5px solid #fff;
  padding: 8px 10px;
  border-radius: 3px;
  background: transparent;
  cursor: pointer;
  margin: 20px 0;
  display: block;
  &:focus {
    outline: none;
  }
  color: #fff;
  option {
    padding-bottom: 10px !important;
    color: $gray-6;
    font-size: 16px;
  }
  .light & {
    color: $gray-6;
    background-color: #fcfcfc;
    border: 0.5px solid $gray-5;
  }
}
.chooseDrop {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between !important;
  border: 1px solid #fff;
  border-radius: 3px;
  padding: 10px;
  cursor: pointer;
  width: 200px !important;
  height: 38px;
  img {
    width: 11px;
    height: 11px;
  }
  .light & {
    border: 1px solid $gray-5;
    color: $gray-6;
  }
}

@media (max-width: 767.98px) {
  .partnerForm {
    .btnEditGroup {
      margin: 50px 0 !important;
      justify-content: center !important;
    }
  }
}
</style>
